module.exports = __webpack_public_path__ + "img/alipay_nocontent.eb9a1802.png";